// extracted by mini-css-extract-plugin
module.exports = {"w1e2q9l8":"w1e2q9l8","s1uqj89y":"s1uqj89y"};